import {
  IInlineNode,
  INoteNode,
  IQuestionNode,
} from 'components/ingestion/IngestedTree'
import { NodeType } from 'shared/types/ingestion'
import { createNoteNode } from 'ingestion/nodeCreationHelpers'

export function createMultiPartQuestion(
  questionText: string,
  title: string,
  questions: (IQuestionNode | INoteNode)[],
): IInlineNode {
  return {
    type: NodeType.Inline,
    data: {
      title,
      studentFacing: true,
      type: NodeType.MultiPartQuestion,
    },
    nodes: [
      createNoteNode({
        title: 'Description',
        value: questionText,
        studentFacing: true,
      }),
      ...questions,
    ],
  }
}
